import { DecimalPipe, NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ElevenLabsModelTypeArr } from '@shared/index';
import { CardModule } from 'primeng/card';
import { SelectModule } from 'primeng/select';
import { SliderModule } from 'primeng/slider';
import { TooltipModule } from 'primeng/tooltip';
import { AudioBtnComponent } from 'src/app/shared/components/ai-bot/utils/bot-chat-dialog/audio-btn/audio-btn.component';
import { FormForBooleanComponent } from 'src/app/shared/components/ai-bot/utils/form-for-boolean/form-for-boolean.component';
import { SubmenuComponent } from 'src/app/shared/components/submenu/submenu.component';
import { SubmenuserviceService } from 'src/app/shared/components/submenu/submenuservice.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { VoiceService } from 'src/app/shared/services/voice.service';
import { CodemirrorCssComponent } from "../../../../../../../shared/components/ai-bot/utils/codemirror-css/codemirror-css.component";
import { HintComponent } from "@shared-angular/components/hint/hint.component";
import { ManualLinkComponent } from "../../../../../../../shared/components/rag-admin/manual-link/manual-link.component";

@Component({
  imports: [NgClass, DecimalPipe, 
    FormsModule,
    FormForBooleanComponent,
    AudioBtnComponent,
    CodemirrorCssComponent,
    HintComponent,
    ManualLinkComponent,
    SubmenuComponent,
    TooltipModule,
    CardModule,
    SelectModule,
    SliderModule
  ],
  templateUrl: './voicebot-tab.component.html',
  styleUrl: './voicebot-tab.component.scss'
})
export class VoicebotTabComponent implements OnInit {
  protected elevenLabsModels = ElevenLabsModelTypeArr;
  protected elevenLabsModelOptions = [...ElevenLabsModelTypeArr];
  //i18n
  public showPrompt = $localize`:@@show-prompt:Chat-Eingabezeile anzeigen`;
  public voiceInput = $localize`:@@voice-input:Spracheingabe`;
  public redirectChat = $localize`:@@redirect-chat:Wechseln zu Chat`;
  public redirectAvatar = $localize`:@@redirect-avatar:Wechseln zu Avatar`;
  public cancelThinking = $localize`:@@cancel-thinking:Bot-Denken abbrechen`;
  public enterCustomCss = $localize`:@@enter-custom-css:Gib deinen CSS-Code hier ein…`;
  public voiceBoost = $localize`:@@voice-boost:Sprech-Boost`;
  //end

  constructor(
    public rss: RouteShareService,
    public submenuService: SubmenuserviceService,
    protected voiceService: VoiceService,
    private toastr: ToastrService
  ) { }

  public ngOnInit(): void {
    if (this.voiceService.voices.length !== 0 && this.rss.botConfig.voiceConfig.id !== 'zufällig' && !this.voiceService.voices.find((v) => v.voiceId === this.rss.botConfig.voiceConfig.id)) {
      this.rss.botConfig.voiceConfig.id = 'zufällig';
      void this.rss.saveBotConfigField('voiceConfig');
      this.toastr.info("BOT_UPDATED", "Die bisherige Stimme wurde seitens Anbieter eingestellt, die Einstellung wurde auf 'Zufällig' gestellt.", { timeOut: 5000 });
    }
  }

  protected sliderChange(value: string, field: 'stability' | 'similarity_boost' | 'style' | 'speed') {
    this.rss.botConfig.voiceConfig[field] = parseFloat(value);
    void this.rss.saveBotConfigField('voiceConfig');
  }
}
